import { CONTACT_TYPES } from "@core/constants";
import { NativeCommunicationManager } from "@core/managers/native-communication.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { ScrollManager } from "@core/managers/scroll.manager";
import { RecruitmentCandidatesService } from "@core/services";

import { ETAB_ROUTES } from "@etab/config";
import { ACTION_RECRUITMENTS_SET_SELECTED_EXTRA, GETTER_RECRUITMENTS_GET_SELECTED_EXTRA } from "@etab/stores/types";
import { useRecruitmentsStore } from "@etab/stores/recruitments";

export const recruitmentCandidateMixin = {
  methods: {
    $_scrollToPreviouslyOpenedExtra() {
      const recruitmentsStore = useRecruitmentsStore();
      // get the selected recruitment (if any)
      const selectedExtraId = recruitmentsStore[GETTER_RECRUITMENTS_GET_SELECTED_EXTRA];
      if (selectedExtraId) {
        const selectedEl = document.getElementById(selectedExtraId);
        if (selectedEl) {
          // if we find one,we scroll to it
          ScrollManager.scrollToElement(selectedEl);
        }
        // we want this to be a one time access, in order to prevent weird behavior on navigation
        recruitmentsStore[ACTION_RECRUITMENTS_SET_SELECTED_EXTRA](undefined);
      } else {
        ScrollManager.scrollToTop();
      }
    },
    $_goToProfileFromPermanentDemand({ candidate }) {
      const candidateId = candidate.getId();
      const query = this.$route.query;
      const demandId = this.$route.params.demandId;
      const demandType = this.$route.params.demandType;

      this.$router
        .push({
          name: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.root.name,
          params: { demandId, demandType, candidateId },
          query: { ...query },
        })
        .catch((suppressedError) => {});
    },
    $_goToProfileFromTemporaryDemand({ candidate }) {
      const candidateId = candidate.getId();
      const demandId = this.$route.params.demandId;
      const demandType = this.$route.params.demandType;
      this.$router
        .push({
          name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.profile.name,
          params: { candidateId, demandType, demandId },
        })
        .catch((suppressedError) => {});
    },
    $_goToMissionFromTemporaryDemand({ candidate }) {
      const candidateId = candidate.getId();
      const demandId = this.$route.params.demandId;
      const demandType = this.$route.params.demandType;
      this.$router
        .push({
          name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.mission.name,
          params: { candidateId, demandType, demandId },
        })
        .catch((suppressedError) => {});
    },
    $_onContactCandidate({ candidate, contactCallback = () => {} }) {
      const { firstname, phone, email } = candidate.getIdentity();

      const actions = [];
      if (phone) {
        actions.push({
          label: this.$t("ETAB.PAGES.RECRUITMENT.@PHONE_CALL"),
          icon: "icon-f-phone-call",
          id: CONTACT_TYPES.PHONE,
        });
        actions.push({
          label: this.$t("ETAB.PAGES.RECRUITMENT.@SMS"),
          icon: "icon-f-message-square",
          id: CONTACT_TYPES.SMS,
        });
      }
      if (email) {
        actions.push({
          label: this.$t("ETAB.PAGES.RECRUITMENT.@EMAIL"),
          icon: "icon-f-mail",
          id: CONTACT_TYPES.MAIL,
        });
      }

      if (actions.length > 0) {
        this.$q
          .bottomSheet({
            message: this.$t("ETAB.PAGES.RECRUITMENT.@CONTACT_CANDIDATE_FIRSTNAME", { firstname }),
            actions,
          })
          .onOk((action) => {
            contactCallback({ candidate });
            switch (action.id) {
              case CONTACT_TYPES.PHONE: {
                NativeCommunicationManager.phone({ phone });
                break;
              }
              case CONTACT_TYPES.SMS: {
                NativeCommunicationManager.sms({ phone });
                break;
              }
              default:
              case CONTACT_TYPES.MAIL: {
                NativeCommunicationManager.sendEmail({ to: email });
                break;
              }
            }
          });
      }
    },
    async $_ignorePermanentCandidate({ candidate }) {
      const candidateId = candidate.getId();
      await RecruitmentCandidatesService.ignorePermanentCandidate({ demandId: this.demandId, candidateId });
      const message = this.$t("SUCCESS.@CANDIDATE_IGNORED_WITH_NAME", { name: candidate.getFirstname() });
      NotificationsManager.success({ message });
    },
    async $_ignoreAECandidate({ candidate }) {
      const candidateId = candidate.getId();
      const demandId = this.$route.params.demandId;
      await RecruitmentCandidatesService.ignoreAECandidate({ demandId, candidateId });
      const message = this.$t("SUCCESS.@CANDIDATE_IGNORED_WITH_NAME", { name: candidate.getFirstname() });
      NotificationsManager.success({ message });
    },
    async $_ignoreMERCandidate({ candidate }) {
      const candidateId = candidate.getId();
      const demandId = this.$route.params.demandId;
      await RecruitmentCandidatesService.ignoreMERCandidate({ demandId, candidateId });
      const message = this.$t("SUCCESS.@CANDIDATE_IGNORED_WITH_NAME", { name: candidate.getFirstname() });
      NotificationsManager.success({ message });
    },
    async $_reportCandidate({ candidateId, demandId, reasonId, comment }) {
      await RecruitmentCandidatesService.reportPermanentCandidate({ candidateId, demandId, reasonId, comment });
      NotificationsManager.success({ message: this.$t("SUCCESS.@CANDIDATE_REPORTED") });
    },
  },
};
